export default [
  {
    title: 'Character Question',
    key: 'question',
    dataIndex: 'question'
  }
];
